import EmployeeAttendance from './employeeAttendance';

export default EmployeeAttendance;
